<template>

  <div class="conversation-header d-flex align-items-center border-bottom bg-white px-3 py-2">

    <Avatar
      class="flex-shrink-0"
      :src="photo"
      :name="displayName"
      size="38px"
      radius="19px" />

    <div class="conversation-header-info flex-grow-1 mx-3">
      <div class="font-weight-bold text-truncate">{{ displayName }}</div>
      <small
        v-if="subtitle"
        class="d-block text-truncate text-muted">{{ subtitle }}</small>
    </div>

    <div class="d-flex align-items-center flex-shrink-0">
      <slot name="actions"></slot>
    </div>

  </div>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'ConversationHeader',
  components: {
    Avatar
  },
  props: {
    conversation: {
      type: Object,
      default: null
    }
  },
  computed: {
    displayName () {
      if (!this.conversation) {
        return ''
      }
      return this.conversation.name || this.conversation.contact_address || this.$t('No name')
    },
    // the only picture of a conversation is the one of the associated candidate
    photo () {
      const candidate = this.conversation && this.conversation.candidate_id
      const url = candidate && candidate.photo_media_url
      return url && !url.includes(config.default_image_url.candidate) ? url : null
    },
    // the address is only worth repeating when the name is already shown above
    subtitle () {
      if (!this.conversation || !this.conversation.contact_address) {
        return ''
      }
      return this.conversation.contact_address
    }
  }
}
</script>

<style scoped>
/* allow the name/subtitle column to shrink so text-truncate works */
.conversation-header-info {
  min-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/conversation/ConversationHeader.vue